import Service from './service'
export var ApiSystemMessageType;
(function (ApiSystemMessageType) {
  ApiSystemMessageType["APPLICATION_FINISH"] = "system.application.finish"
  ApiSystemMessageType["POWER_CONTROL"] = "system.power.control"
  ApiSystemMessageType["SYSTEM_LANGUAGE"] = "system.language"
})(ApiSystemMessageType || (ApiSystemMessageType = {}))
export var SystemMessageType;
(function (SystemMessageType) {
  SystemMessageType["SYSTEM_LANGUAGE"] = "SYSTEM_LANGUAGE"
  SystemMessageType["APPLICATION_FINISH"] = "APPLICATION_FINISH"
})(SystemMessageType || (SystemMessageType = {}))
var Device;
(function (Device) {
  Device[Device["PrinterPhoto"] = 0] = "PrinterPhoto"
  Device[Device["PrinterThermal"] = 1] = "PrinterThermal"
  Device[Device["Dispenser"] = 2] = "Dispenser"
  Device[Device["Display"] = 3] = "Display"
  Device[Device["ServosNeck"] = 4] = "ServosNeck"
  Device[Device["ServosArmLeft"] = 5] = "ServosArmLeft"
  Device[Device["ServosArmRight"] = 6] = "ServosArmRight"
  Device[Device["ServosTorso"] = 7] = "ServosTorso"
  Device[Device["HubLinux"] = 8] = "HubLinux"
  Device[Device["HubWin"] = 9] = "HubWin"
  Device[Device["HubPowerboard"] = 10] = "HubPowerboard"
  Device[Device["Vescs"] = 11] = "Vescs"
  Device[Device["Ranges"] = 12] = "Ranges"
})(Device || (Device = {}))
export var ApplicationFinishStatus;
(function (ApplicationFinishStatus) {
  /** Приложение завершилось успешно */
  ApplicationFinishStatus[ApplicationFinishStatus["Success"] = 0] = "Success"
  /** Приложение завершилось ошибкой */
  ApplicationFinishStatus[ApplicationFinishStatus["Failed"] = 1] = "Failed"
  /** Приложение завершилось по таймауту */
  ApplicationFinishStatus[ApplicationFinishStatus["Timeout"] = 2] = "Timeout"
  /** Пользовательский статус завершения */
  ApplicationFinishStatus[ApplicationFinishStatus["User"] = 100] = "User"
})(ApplicationFinishStatus || (ApplicationFinishStatus = {}))
/**
 * Сервис для работы с системами робота
 * @version 0.0.1
 * @since 2.0.0
 */
export default class SystemService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiSystemMessageType.APPLICATION_FINISH:
          delete message.id
          delete message.type
          this.broadcast(SystemMessageType.APPLICATION_FINISH, message)
          break
        case ApiSystemMessageType.SYSTEM_LANGUAGE:
          this.broadcast(SystemMessageType.SYSTEM_LANGUAGE, message.lang)
          break
      }
    }
    this.messageChannel.subscribe(ApiSystemMessageType.SYSTEM_LANGUAGE, messageHandler)
    this.messageChannel.subscribe(ApiSystemMessageType.APPLICATION_FINISH, messageHandler)
  }
  /**
     * Сервис передал данные о закрытии другого плагина
     * @since 2.0.0
     * @param {(data: ApplicationFinishData) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof SystemService
     *
     * @example <caption>Сервис передал данные о закрытии другого плагина</caption>
     * robot.systemService.onApplicationFinished((data) => {
     *   ...
     * })
     */
  onApplicationFinished(callback) {
    return this.subscribe(SystemMessageType.APPLICATION_FINISH, callback)
  }
  /**
     * Сервис сообщил об установке языка
     * @since 2.0.0
     * @param {(locale: string) => void} callback
     * locale - язык в форме "language_country", где language - строчное двухбуквенное представление
     * языкового кода в формате ISO-639, и country - Заглавное, двух- или трёх-буквенное представление кода страны в формате ISO-3166
     * Например: en_US, ru_RU
     * @return {*}  {UnsubscribeFunction}
     * @memberof SystemService
     *
     * @example <caption>Cервис сообщил об установке языка</caption>
     * robot.systemService.onLanguage((locale) => {
     *   ...
     * })
     */
  onLanguage(callback) {
    return this.subscribe(SystemMessageType.SYSTEM_LANGUAGE, callback)
  }
  /**
     * Включить питание на девайсе
     * @since 2.0.0
     * @param {Device} device - код устройства
     * @memberof SystemService
     *
     * @example <caption>Включить питание на девайсе</caption>
     * robot.systemService.powerOn(device)
     */
  powerOn(device) {
    this.messageChannel.send({
      type: ApiSystemMessageType.POWER_CONTROL,
      enable: device,
    })
  }
  /**
     * Выключить питание на девайсе
     * @since 2.0.0
     * @param {Device} device - код устройства
     * @memberof SystemService
     *
     * @example <caption>Выключить питание на девайсе</caption>
     * robot.systemService.powerOff(device)
     */
  powerOff(device) {
    this.messageChannel.send({
      type: ApiSystemMessageType.POWER_CONTROL,
      disable: device,
    })
  }
}
